<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminGroupOrder.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="conditions" class="flex justify-start">
            <el-form-item>
              <el-input :placeholder="$t('adminGroupOrder.orderIdPlaceholder')" v-model="conditions.orderId" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('adminGroupOrder.prodNamePlaceholder')" v-model="conditions.prodName"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('adminGroupOrder.buyerNamePlaceholder')" v-model="conditions.buyerName"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('adminGroupOrder.groupBuyerNamePlaceholder')"
                v-model="conditions.groupBuyerName" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="conditions.state" :placeholder="$t('adminGroupOrder.statePlaceholder')"
                style="width:100%">
                <el-option :label="$t('adminGroupOrder.allStatus')" value="">
                </el-option>
                <el-option :label="$t('adminGroupOrder.groupSuccess')" value="1001">
                </el-option>
                <el-option :label="$t('adminGroupOrder.groupFail')" value="2002">
                </el-option>
                <el-option :label="$t('adminGroupOrder.grouping')" value="3003">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryProductGroupOrder" icon="el-icon-search">
                {{ $t('adminGroupOrder.search') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminGroupOrder.groupOrder') }}</span>
          </div>
          <el-table :data="orders" border style="width: 100%">
            <el-table-column prop="orderId" :label="$t('adminGroupOrder.orderId')" align="center">
            </el-table-column>
            <el-table-column :label="$t('adminGroupOrder.productImage')" align="center">
              <template slot-scope="scope">
                <el-image style="width: 50px; height: 50px; border-radius: 10px;"
                  :src="scope.row.coverPhoto || '/img/noPhoto.jpg'" fit="cover">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column :label="$t('adminGroupOrder.productName')" align="center">
              <template slot-scope="scope">
                【{{ scope.row.userCount }}人团】{{ scope.row.prodName }}
              </template>
            </el-table-column>
            <el-table-column prop="buyerName" :label="$t('adminGroupOrder.buyer')" align="center">
            </el-table-column>
            <el-table-column prop="groupBuyerName" :label="$t('adminGroupOrder.groupLeader')" align="center">
            </el-table-column>
            <el-table-column prop="buyerCount" :label="$t('adminGroupOrder.buyCount')" align="center">
            </el-table-column>
            <el-table-column :label="$t('adminGroupOrder.groupCount')" align="center">
              <template slot-scope="scope">
                {{ scope.row.groupCount }}/{{ scope.row.userCount }}
              </template>
            </el-table-column>
            <el-table-column prop="groupPrice" :label="$t('adminGroupOrder.groupAmount')" align="center">
            </el-table-column>
            <el-table-column prop="stateName" :label="$t('adminGroupOrder.status')" align="center">
            </el-table-column>
            <el-table-column prop="rebateAmount" :label="$t('adminGroupOrder.rebateAmount')" align="center">
            </el-table-column>
            <el-table-column prop="openTime" :label="$t('adminGroupOrder.openTime')" align="center">
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('adminGroupOrder.groupTime')" align="center">
            </el-table-column>
            <el-table-column prop="endTime" :label="$t('adminGroupOrder.deadline')" align="center">
            </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminGroupOrder } from '@/api/group/adminGroupOrderApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  components: {
    AdminShop
  },
  data() {
    return {
      orders: [],
      conditions: {
        orderId: '',
        prodName: '',
        buyerName: '',
        groupBuyerName: '',
        state: '',
        shopId: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.listProductGroupOrders()
  },
  methods: {
    handleShopChange(shop) {
      this.conditions.shopId = shop.shopId
      this.listProductGroupOrders()
    },
    queryProductGroupOrder() {
      this.currentPage = 1
      this.listProductGroupOrders()
    },
    listProductGroupOrders() {
      const params = {
        ...this.conditions,
        page: this.currentPage,
        row: this.pageSize
      }

      queryAdminGroupOrder(params).then(res => {
        this.orders = res.data
        this.total = res.records
      }).catch(error => {
        console.error('获取拼团订单失败:', error)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listProductGroupOrders()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.listProductGroupOrders()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.box-card {
  margin-bottom: 20px;
}
</style>